import React from 'react';
import PropsType from 'prop-types';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { getCurrentCountry } from '@/utils/domain';

import InputComponent from '../Input';

import './index.scss';

function InputPhone({ onChangeCountryCode, label, country, ...props }) {

  const currentCountry = getCurrentCountry();
  const handleOnChange = (phone) => {
    if (onChangeCountryCode) {
      onChangeCountryCode(phone);
    }
  };

  return (
    <div className="input-phone">
      {label && <p className="sms-input__label">{label}</p>}
      <div className="input-phone__container">
        <PhoneInput
          country={currentCountry || country || 'th'}
          searchPlaceholder="Search"
          specialLabel=""
          inputClass="input-phone"
          inputProps={{
            required: true,
          }}
          countryCodeEditable={false}
          onChange={handleOnChange}
          onlyCountries={[`${currentCountry}`]}
          disableDropdown
        />
        <InputComponent type="number" label="" {...props} />
      </div>
    </div>
  );
}

InputPhone.propTypes = {
  country: PropsType.string,
  label: PropsType.string,
  onChangeCountryCode: PropsType.func,
};

export default InputPhone;
